if (!customElements.get('mt-video-slider')) {
  customElements.define(
    'mt-video-slider',
    class MtVideoSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-video-track]');
        if (!this.track) return;

        this.slides = Array.from(this.querySelectorAll('[data-video-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-video-dot]'));
        this.prevBtn = this.querySelector('[data-video-prev]');
        this.nextBtn = this.querySelector('[data-video-next]');
        this.index = 0;
        this.ticking = false;

        this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.videoDot)));
        });

        this.track.addEventListener(
          'scroll',
          () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              const step = this.getStep();
              const current = Math.round(this.track.scrollLeft / step);
              if (current !== this.index) this.update(current);
            });
          },
          { passive: true }
        );

        this.resizeObserver = new ResizeObserver(() => this.update(this.index));
        this.resizeObserver.observe(this.track);
        this.update(0);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      getVisibleCount() {
        const visible = Number.parseFloat(getComputedStyle(this).getPropertyValue('--video-slider-visible'));
        const count = Number.isFinite(visible) && visible > 0 ? Math.round(visible) : 3;
        return Math.max(1, Math.min(count, this.slides.length || 1));
      }

      getStep() {
        const slide = this.slides[0];
        if (!slide) return this.track.clientWidth || 1;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap || 1;
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.getVisibleCount());
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.maxIndex()));
        this.track.scrollTo({ left: target * this.getStep(), behavior: 'smooth' });
        this.update(target);
      }

      update(index) {
        const max = this.maxIndex();
        this.index = Math.max(0, Math.min(index, max));
        const visible = this.getVisibleCount();
        this.slides.forEach((slide, i) => {
          const inView = i >= this.index && i < this.index + visible;
          slide.classList.toggle('is-active', inView);
          if (!inView) {
            slide.querySelectorAll('video').forEach((video) => {
              if (!video.paused) video.pause();
            });
          }
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index >= max;
      }
    }
  );
}
